export default "__VITE_ASSET__rNoSLx9E__"